@tailwind base;
@tailwind components;
@tailwind utilities;

.ids-alert-body:last-child {
  padding-inline-end: 8px;
}
